import { FC } from "react";
import { BaseMenuItem, MenuValue } from "../model";
import "./style.scss";

interface SubMenuItemPropTypes {
  activeSubMenu: MenuValue;
  subMenuItem: BaseMenuItem;
  onClickSubMenu: (value: MenuValue, path: string) => void;
}

const SubMenuItem: FC<SubMenuItemPropTypes> = ({
  activeSubMenu,
  subMenuItem,
  onClickSubMenu,
}) => {
  const { label, value, path } = subMenuItem;
  return (
    <div
      className={"submenu-item" + (activeSubMenu === value ? " active" : "")}
      onClick={() => onClickSubMenu(value, path)}
    >
      {label}
    </div>
  );
};

export default SubMenuItem;
